<template>
<div class="mt-5 paginationContainer">
    <nav aria-label="Paginação de dados">
        <ul class="customPagination pagination">
            <li>
                <ul class="customPagination pagination">
                    <li v-for="(opcao) in opcoesDeRegistrosPorPagina" :key="(opcao).key" :class="(disabled == true ? 'page-item disabled' : (registrosPorPagina == opcao ? 'page-item active' : 'page-item'))">
                        <span v-if="registrosPorPagina == opcao" :class="{'page-link-gestao-conta': opcaoMenuGestaoConta}" class="page-link">{{ opcao }}</span>
                        <a v-if="registrosPorPagina != opcao" class="page-link" href="#" @click="navegarNaPaginacao($event, 1, opcao)">{{ opcao }}</a>
                    </li>
                </ul>
            </li>
            <li class="ml-auto">
                <ul class="customPagination pagination">
                  <li :class="classBotaoAnterior">
                    <a class="page-link" href="#" @click="navegarNaPaginacao($event, fonteDeDados.paginaAtual-1)" aria-label="Anterior">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li v-for="(pagina) in paginas" :key="(pagina).key" :class="(disabled == true ? 'page-item disabled' : (fonteDeDados.paginaAtual == pagina ? 'page-item active' : 'page-item'))">
                    <span v-if="pagina == '...'" class="page-link">...</span>
                    <a v-if="pagina != '...'" :class="{'page-link-gestao-conta': opcaoMenuGestaoConta}" class="page-link" href="#" @click="navegarNaPaginacao($event, pagina)">{{ pagina }}</a>
                  </li>
                  <li :class="classBotaoProximo">
                    <a class="page-link" href="#" @click="navegarNaPaginacao($event, fonteDeDados.paginaAtual+1)" aria-label="Próximo">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
            </li>
        </ul>
        <div class="contador-registros mt-3">
          <small class="text-muted">
              {{ contadorRegistros }}
          </small>
        </div>
    </nav>
</div>
</template>

<script>
import pagination from './js'
export default pagination
</script>

<style scoped>
@import "./scss/pagination.scss";
</style>
